export enum PetitionStatus {
  Received = 'recibida',
  InProcess = 'en_proceso',
  Waiting = 'en_espera',
  Resolved = 'resuelta',
  Approved = 'aprobada',
  Rejected = 'rechazada',
}

export enum STUDENT_STATUS {
  REGULAR = 'regular',
  INSTITUTIONAL_RETRACTED = 'retractado_institucional',
  WITHDRAWN_STUDY_PLAN = 'retractado_del_plan_de_estudio',
  SUSPENDED = 'suspendido',
  CANCELED = 'anulado',
  RESIGNED = 'renunciado',
  EXPELLED = 'expulsado',
  POSTPONED = 'postergado',
  ABANDON = 'abandono',
  REINCORPORATED = 'reincorporado',
  GRADUATE = 'egresado',
  TITLED = 'titulado',
}
